import { SpherePlatformAppPaths } from '@sphere/platform';

export const IA_PATH = 'instant-analyst';
export const IA_INTELLIGENCE_BASIC_PATH = 'intelligence-basic';
export const IA_INTELLIGENCE_PATH = 'intelligence';
export const IA_MARKET_SCAN = 'insite-edge';

export const PATHS: SpherePlatformAppPaths = {
    ['IA_PATH']: 'instant-analyst',
    ['IA_INTELLIGENCE_BASIC_PATH']: 'intelligence-basic',
    ['IA_INTELLIGENCE_PATH']: 'intelligence',
    ['IA_MARKET_SCAN']: 'insite-edge'
};
